module.exports = __webpack_public_path__ + "img/searchicon.2c449603.svg";